import { fromIsoDay } from "components/crm/ui/crmTime";
import { clock, longDay, whenKey } from "pages/prospection/callTime";

export const RESULTS = ["answered", "callback", "no_answer", "not_interested"];
export const THIRD_ACTIONS = ["visit", "tomorrow", "keep", "remove"];
export const MAX_ATTEMPTS = 3;

export const missedInARow = (calls) => {
  let count = 0;
  for (const call of calls || []) {
    if (call.result !== "no_answer") break;
    count += 1;
  }
  return count;
};

export const currentAttempt = (calls) => missedInARow(calls) + 1;

export const canConfirm = ({ result, note, at, history, attempt }) => {
  const hasNote = !!note && note.trim() !== "";
  switch (result) {
    case "answered":
    case "not_interested":
      return hasNote;
    case "callback":
      return hasNote && !!at;
    case "no_answer":
      return history != null && (attempt >= MAX_ATTEMPTS || !!at);
    default:
      return false;
  }
};

const buildFollowUp = ({ result, visit, at, action, attempt }) => {
  if (result === "answered") return { visit: !!visit };
  if (result === "callback") return { at: at.toISOString() };
  if (result === "no_answer") {
    return attempt >= MAX_ATTEMPTS ? { action } : { at: at.toISOString() };
  }
  return undefined;
};

export const buildConfirmBody = ({
  company,
  line,
  sessionId,
  result,
  note,
  visit,
  at,
  action,
  attempt,
}) => ({
  companyId: company.id,
  callbackId: line?.id ?? null,
  sessionId: sessionId ?? null,
  result,
  note: note.trim(),
  contactName: company.contactName || "",
  followUp: buildFollowUp({ result, visit, at, action, attempt }),
});

const ORDINAL_KEYS = { 1: "one", 2: "two", 3: "three" };

export const ordinal = (n, text) =>
  text(`qualification.ordinal.${ORDINAL_KEYS[n] || "other"}`, { n });

export const whenText = (at, now, text, locale) =>
  text(`when.${whenKey(at, now)}`, {
    time: clock(at),
    day: longDay(at, locale),
  });

// Dates come from the api response, never from the user's choice: the server
// may have kept an earlier callback time.
export const confirmMessage = (response, { company, now, text, locale }) => {
  const values = { company: company.name, n: response.attempt };
  if (response.visit) {
    values.date = longDay(fromIsoDay(response.visit.dueBy), locale);
  }
  if (response.dueAt) {
    values.when = whenText(new Date(response.dueAt), now, text, locale);
  }
  return text(`confirmed.${response.outcome}`, values);
};
